<template>
  <div>
    <div class="separator-breadcrumb border-top"></div>
    <div class="row">
      <div class="col-md-12">
        <div class="card mb-4">
          <div class="card-body">
            <div class="card-title mb-3">New trip per truck</div>
            <fieldset class="border p-3">
              <p></p>
              <div></div>
              <div>
                <div class="trucksLoader">
                  <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <i
                    class="fa fa-spinner fa-spin"
                    style="font-size: 24px; color: blue"
                  ></i
                  >loading trucks...
                </div>
                <vue-good-table
                  :columns="columns"
                  :rows="systemTrucks"
                  :pagination-options="{
                    enabled: true,
                    mode: 'records',
                    perPage: 6,
                    position: 'bottom',
                    perPageDropdown: [3, 7, 9],
                    dropdownAllowAll: false,
                    setCurrentPage: 1,
                    nextLabel: 'next',
                    prevLabel: 'prev',
                    rowsPerPageLabel: 'Rows per page',
                    ofLabel: 'of',
                    pageLabel: 'page', // for 'pages' mode
                    allLabel: 'All',
                  }"
                >
                  <template slot="table-row" slot-scope="props">
                    <span v-if="props.column.field == 'faulty_status'">
                      <span v-if="props.row.Faulty_status === 0">
                        <button class="btn btn-info btn-sm btn-flat">
                          <i class="fa fa-level-up"></i> NOT FAULTY
                        </button>
                      </span>
                      <span v-else-if="props.row.Faulty_status === 1">
                        <button class="btn btn-danger btn-sm">
                          <i class="fa fa-level-down"></i> FAULTY
                        </button>
                      </span>
                    </span>
                    <span v-if="props.column.field == 'truck_status'">
                      <span v-if="props.row.Truck_status === 0">
                        <button class="btn btn-info btn-sm btn-flat">
                          <i class="fa fa-level-up"></i> AVAILABLE
                        </button>
                      </span>
                      <span v-else-if="props.row.Truck_status === 1">
                        <button class="btn btn-danger btn-sm">
                          <i class="fa fa-level-down"></i> ENROUTE
                        </button>
                      </span>
                    </span>

                    <span v-else-if="props.column.field == 'Action'">
                      <button
                        v-b-tooltip.hover.bottom="'Edit truck!'"
                        class="btn btn-primary btn-sm btn-rounded"
                        @click="viewTruck(props.row.id)"
                      >
                        <i class="fa fa-edit"></i> Edit Trucks
                      </button>
                    </span>

                    <span v-else-if="props.column.field == 'Logbook'">
                      <button
                        class="btn btn-primary btn-sm btn-rounded"
                        @click="viewTruckdocument(props.row.id)"
                      >
                        <i class="fa fa-edit"></i> Logbook
                      </button>
                    </span>

                    <span v-else-if="props.column.field == 'Trip'">
                      <button
                        class="btn btn-primary btn-sm btn-rounded"
                        @click="viewTrucktrip(props.row.id)"
                      >
                        <i class="fa fa-plus"></i> Add Trip
                      </button>
                    </span>

                    <span v-else>{{
                      props.formattedRow[props.column.field]
                    }}</span>
                  </template>
                </vue-good-table>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  <script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      columns: [
        {
          label: "Transporter name",
          field: "transporter_name",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter transporter",
          },
        },
        {
          label: "Truck number",
          field: "truck_no",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter truck number",
          },
        },
        {
          label: "Trailer number",
          field: "trailer_no",
          type: "text",
        },
        {
          label: "Driver name",
          field: "driver_name",
          type: "text",
        },
        {
          label: "Driver phone",
          field: "driver_phone",
          type: "text",
        },
        {
          label: "Id number",
          field: "driver_id_number",
          type: "text",
        },
        {
          label: "Truck status",
          field: "truck_status",
          type: "text",
        },
        {
          label: "Action",
          field: "Action",
          width: "122px",
          html: true,
        },
        {
          label: "Logbook",
          field: "Logbook",
          width: "122px",
          html: true,
        },
        {
          label: "Trip",
          field: "Trip",
          width: "122px",
          html: true,
        },
      ],
    };
  },
  created() {
    this.loadTrucks();
  },
  computed: {
    ...mapGetters(["systemTrucks", "Truck"]),
  },
  methods: {
    ...mapActions([
      "loadTrucks",
      "viewTruck",
      "loadTruck",
      "newJobcard",
      "TruckcheckIn",
      "viewTrucktrip",
      "viewTruckdocument",
    ]),
  },
};
</script>
  <style scoped>
.creatingTruckAttendanceLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/trips/newtrip.vue